// forms
export const TRADE_WASTE_FORM = 'tradeWaste'

export const SELECT_OPTIONS = ['0', '1', '2', '3', '4', '5']
export const SELECT_OPTIONS_SHOWER_TIMER = ['1', '2']
export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

export const TIMES = [
  '12:00 AM',
  '12:30 AM',
  '1:00 AM',
  '1:30 AM',
  '2:00 AM',
  '2:30 AM',
  '3:00 AM',
  '3:30 AM',
  '4:00 AM',
  '4:30 AM',
  '5:00 AM',
  '5:30 AM',
  '6:00 AM',
  '6:30 AM',
  '7:00 AM',
  '7:30 AM',
  '8:00 AM',
  '8:30 AM',
  '9:00 AM',
  '9:30 AM',
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
  '4:30 PM',
  '5:00 PM',
  '5:30 PM',
  '6:00 PM',
  '6:30 PM',
  '7:00 PM',
  '7:30 PM',
  '8:00 PM',
  '8:30 PM',
  '9:00 PM',
  '9:30 PM',
  '10:00 PM',
  '10:30 PM',
  '11:00 PM',
  '11:30 PM'
]

// ACTIONS
export const UPLOAD = 'UPLOAD'
export const SHOW_FIELD_VALIDATION = 'SHOW_FIELD_VALIDATION'
export const UPDATE_VALUE = 'UPDATE_VALUE'
export const SET_FIELDS = 'SET_FIELDS'
export const ERROR = 'ERROR'
export const DELETE = 'DELETE'
export const DELETE_ALL = 'DELETE_ALL'
export const COMPLETE = 'COMPLETE'
export const IS_COMPLETE = 'IS_COMPLETE'
export const SILENT_CHECK = 'SILENT_CHECK'
export const SET_PAGE = 'SET_PAGE'
export const SET_TRACK = 'SET_TRACK'
export const NEXT = 'NEXT'
export const BACK = 'BACK'
export const SUBMIT = 'SUBMIT'
export const SUBMITTED_SUCCESS = 'SUBMITTED_SUCCESS'
export const SUBMITTED_ERROR = 'SUBMITTED_ERROR'
export const SHOW_ERROR = 'SHOW_ERROR'
export const HIDE_ERROR = 'HIDE_ERROR'
export const RESET = 'RESET'
export const ADD = 'ADD'
// GENERIC
export const NAME = 'name'
export const NUMBER = 'number'
export const EMAIL = 'email'
export const BUSINESS_TRADING_NAME = 'business_trading_name'
export const DATE_OF_CHANGE = 'date_of_change'
export const DESCRIPTION = 'description'

export const APPLICATION_TYPE = 'application_type'
export const PERMIT_NUMBER = 'permit_number'
export const NEW_PERMIT_OTHER = 'new_permit_other'
export const WHICH_BUSINESS = 'which_business'
export const TRADE_WASTE_APPLICATION_TYPE = 'trade_waste_application_type'
export const TRADE_WASTE_CHANGE = 'trade_waste_change'
export const APPLY_NEW_TRADE_WASTE_UNSUPPORTED =
  'APPLY_NEW_TRADE_WASTE_UNSUPPORTED'
export const APPLY_NEW_TRADE_WASTE_PERMIT = 'Apply for a trade waste permit'
export const CHANGE_DETAILS_EXISTING_WASTE_PERMIT =
  'Change details of existing trade waste permit'
export const APPLY_SHARED_GREASE_ARRESTOR =
  'Shared grease arrestor application form'
export const APPLY_SHORT_TERM_WASTE_DISPOSAL =
  'Apply for a one-off or short-term waste disposal permit'

export const SET_STATUS = 'SET_STATUS'

// BUSINESS DETAILS
export const BUSINESS_DETAILS = 'business_details'
export const SHOP_NUMBER = 'unit_shop_number'
export const STREET_NUMBER = 'street_number'
export const STREET_NAME = 'street_name'
export const NEAREST_INTERSECTION = 'nearest_intersection'
export const SUBURB = 'suburb'
export const POSTCODE = 'postcode'
export const BUILDING_SHOPPING_CENTRE_NAME = 'building_shopping_centre_name'

export const ABN = 'abn'
export const COMPANY_NAME = 'company_name'
export const DATE_OF_DISCHARGE = 'date_of_discharge'
export const MAILING_SAME = 'mailing_same'
export const MAILING_ADDRESS = 'mailing_address'
export const MAILING_SUBURB = 'mailing_suburb'
export const MAILING_POSTCODE = 'mailing_postcode'

export const OPERATOR_DETAILS = 'operator_details'
export const OPERATOR_NAME = 'operator_name'
export const OPERATOR_POSITION = 'operator_position'
export const OPERATOR_NUMBER = 'operator_number'
export const OPERATOR_EMAIL = 'operator_email'

export const BUSINESS_HOURS = 'business_hours'
export const REMOVE_BUSINESS_HOURS = 'remove_business_hours'
export const DAY = 'day'
export const FROM = 'from'
export const TO = 'to'

// PROCESS DETAILS
export const PROCESS_DETAILS = 'PROCESS_DETAILS'
export const SEATING_CAPACITY = 'seating_capacity'
export const COOKING_ON_PREMISES = 'cooking_on_premises'

export const KITCHEN = 'KITCHEN'
export const KITCHEN_SINK = 'kitchen_sink'
export const DOUBLE_KITCHEN_SINK = 'double_kitchen_sink'
export const POT_SINK = 'pot_sink'
export const DOUBLE_POT_SINK = 'double_pot_sink'
export const HAND_BASIN = 'hand_basin'
export const WOK_BURNERS = 'wok_burners'
export const COMBI_OVENS = 'combi_ovens'
export const CONNECTING_EXISTING_GREASE_ARRESTOR =
  'connecting_existing_grease_arrestor'
export const CONNECTING_NEW_GREASE_ARRESTOR = 'connecting_new_grease_arrestor'
export const ADDITIONAL_FITOUT_OR_PLUMBING_WORK = 'fitouts_additional_plumbing'

export const MENU = 'proposed_menu'
export const PLUMBING_PLAN = 'plumbing_plan'

export const CONTACT = 'contacts'
export const REMOVE_CONTACT = 'remove_contact'
export const CONTACT_NUMBER = 'contact_number'
export const CONTACT_RELATIONSHIP = 'contact_relationship'
export const CONTACT_NAME = 'contact_name'
export const CONTACT_RELATIONSHIPS = [
  'Property owner',
  'Managing agent',
  'Centre management',
  'Other business'
]
// existing arrestor
export const EXISTING_ARRESTOR = 'EXISTING_ARRESTOR'
export const EXISTING_ARRESTOR_BARCODE = 'existing_arrestor_barcode'
export const EXISTING_ARRESTOR_LOCATION = 'existing_arrestor_location'
export const EXISTING_ARRESTOR_SIZE = 'existing_arrestor_size'
export const EXISTING_ARRESTOR_SHARED = 'existing_arrestor_shared'
export const SHARED_GREASE_ARRESTOR_SERVICING =
  'shared_grease_arrestor_servicing'
export const PERSONS_RESPONSIBLE_SERVICING_GREASE_ARRESTOR =
  'persons_responsible_servicing_grease_arrestor'
// new arrestor
export const NEW_ARRESTOR = 'NEW_ARRESTOR'
export const NEW_ARRESTOR_SIZE = 'new_arrestor_size'
export const NEW_ARRESTOR_MAKE_MODEL = 'new_arrestor_make_model'
export const NEW_ARRESTOR_INSTALL_DATE = 'new_arrestor_install_date'
export const NEW_ARRESTOR_LICENSED_PLUMBER_NAME =
  'new_arrestor_licensed_plumber_name'
export const NEW_ARRESTOR_LICENSED_PLUMBER_CONTACT =
  'new_arrestor_licensed_plumber_contact'

// declaration
export const DECLARATION_NAME = 'declaration_name'
export const DECLARATION_POSITION = 'declaration_position'
export const DECLARATION_COMPANY_NAME = 'declaration_company_name'
export const DECLARATION_PHONE = 'declaration_phone'
export const DECLARATION_EMAIL = 'declaration_email'
export const DECLARATION_CONFIRM = 'declaration_confirm'

// change grease connector
export const CHANGE_DETAILS = 'change_details'
export const CHANGE_REQUEST = 'change_request'

// ROUTES
export const HOME = '/'
export const NEW_ARRESTOR_APPLICATION = '/new'
export const NEW_ARRESTOR_APPLICATION_PROCESS = '/new/process'
export const CHANGE_EXISTING_ARRESTOR_APPLICATION = '/change'
export const CHANGE_EXISTING_ARRESTOR_APPLICATION_DETAIL = '/change/detail'
export const DECLARATION = '/declaration'
export const CONFIRMATION = '/confirmation'
export const RECEIPT = '/receipt'

// regex
export const AustralianPhoneRegex =
  /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/

export const EmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const AbnRegex = /^(\d *?){11}\s*$/

export const BuildingNumberRegex = /\d{0,10}/

export const PostcodeRegex = /^6[0-9][0-9][0-9]$/

// Checklists
export const FIRST_NAME = 'firstName'
export const HOUSE_NUMBER = 'houseNumber'
export const GARDEN_SIZE = 'gardenSize'
export const NUMBER_OF_PEOPLE = 'numberOfPeople'
export const HAS_LAWN = 'hasLawn'
export const HAS_POOL = 'hasPool'
export const HAS_LAUNDRY = 'hasLaundry'
export const HAS_BORE = 'hasBore'

export const GARDEN_SIZE_OPTIONS = [
  'Large garden',
  'Medium garden',
  'Small garden',
  'Balcony garden',
  'No garden'
]
